import { Col, Row, Card } from 'antd'
import { ReactMemoEx } from 'modules/view'
import React from 'react'
import { TableCountryCode } from 'components'

const PanelByCountryCode = () => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Card>
          <TableCountryCode />
        </Card>
      </Col>
    </Row>
  )
}

export default ReactMemoEx(PanelByCountryCode)
